import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "../../Home/home/home.component";
import { AuthGuard } from "../../_common/_authguards/AuthGuard";

import { goonComponent } from "../goon/goon.component";

import { AboutUsComponent } from "../../_Shared/static/about-us/about-us.component";
import { ContactusComponent } from "../../_Shared/static/contactus/contactus.component";

import { FaqComponent } from "../../_Shared/static/faq/faq.component";
import { TermsAndConditionComponent } from "../../_Shared/static/terms-and-condition/terms-and-condition.component";
import { PrivacyPolicyComponent } from "../../_Shared/static/privacy-policy/privacy-policy.component";
import { RefundsComponent } from "../../_Shared/static/refunds/refunds.component";
import { userorderdetailComponent } from "../service/userorderdetail/userorderdetail.component";

import { cartComponent } from "../service/cart/cart.component";
import { CourseContentComponent } from "../service/CourseContent/CourseContent.component";
import { GiftVoucherComponent } from "../wallet-service/GiftVoucher/GiftVoucher.component";
import { PromoListComponent } from "../service/PromoList/PromoList.component";
import { PaymentSuccessComponent } from "../service/payment-success/payment-success.component";

export const PUBLIC_ROUTES: Routes = [
  { path: "", redirectTo: "/Home", pathMatch: "full" },

  { path: "Home", component: HomeComponent },

  { path: "AboutUs", component: AboutUsComponent },
  { path: "Contactus", component: ContactusComponent },

  { path: "TermsAndCondition", component: TermsAndConditionComponent },
  { path: "PrivacyPolicy", component: PrivacyPolicyComponent },

  { path: "Refunds", component: RefundsComponent },
  { path: "Thankyou", component: PaymentSuccessComponent },

  {
    path: "Orderdetail",
    component: userorderdetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "Go-on",
    component: goonComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "Cart",
    component: cartComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "CourseContent",
    component: CourseContentComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "GiftVoucher",
    component: GiftVoucherComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "PromoList",
    component: PromoListComponent,
    canActivate: [AuthGuard],
  },
];
